<div fxLayout="row" fxLayoutAlign="space-evenly center" class="container">
  <button mat-button color="primary" (click)="gotIt()">Got It</button>
  <button mat-button color="primary" (click)="isOrdered()">Ordered</button>
  <button mat-button color="primary" (click)="outOfStock()">Out of Stock</button>
  <button mat-button color="primary" (click)="isReady()">Ready</button>
</div>